import { render, staticRenderFns } from "./167.vue?vue&type=template&id=135fe613&scoped=true&"
var script = {}
import style0 from "./167.vue?vue&type=style&index=0&id=135fe613&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135fe613",
  null
  
)

export default component.exports